import formatTotalBalance from "../../../../../utils/formatTotalBalance";
import { standardAccountNumberFormat } from "../../../../../utils/standardAccountNumberFormat";
import FormatAmount from "../../../FormatAmount/FormatAmount";
import CardActionableButton from "../CardActionableButton";
import TickerAnimation from "../../../../../components/_utils/TickerAnimation";
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef IconComponent
 * @type {object}
 * @property {String} icon - Icon to show
 * @property {String} bgColor - Background color of icon var only
 * @property {String} [title] - Text to show on hover
 * @property {Boolean} isDisabled
 * @property {String} props.imgColor - Color for icon if needed (var Only)
 * @property {OnClickEventHandler} [onClick] - If this is not undefined, this button will be made actionable.
 *
 */
/**
 * @typedef {("normal" | "semibold")} fontWeight
 * @typedef {("AccountNumber" | "Amount" | "Text")} type
 * @typedef {("lowercase" | "uppercase" | "capitalize")} textCase
 * @param {Object} props
 * @param {String} props.text - Header text
 * @param {String} props.subText - Subtext
 * @param {String} props.textColor - Header text color (var only)
 * @param {fontWeight} props.fontWeight - font weight of the header text
 * @param {type} props.type - type of the header text
 * @param {textCase} props.textCase - text casing of the header text
 * @param {boolean} props.isAbbrevation - amount abbrevation
 * @param {string} props.currency - amount to be formatted in
 * @param {string} props.balance - account balance
 * @param {IconComponent[]} props.iconComponentArray - Array of what icons to show
 *
 * @returns {JSX.Element}
 */
const TextWithIcon = ({
  text,
  textColor,
  fontWeight,
  subText,
  iconComponentArray,
  type,
  textCase,
  isAbbrevation,
  currency,
  balance,
}) => {
  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };
  return (
    <div className="flex flex-col px-padding-sm gap-y-gap-xs">
      <div className="w-full flex justify-between items-center ">
        <p
          className={`text-font-sm flex-1 truncate font-${fontWeight}`}
          style={{
            textTransform: textCase,
            color: textColor,
          }}
        >
          {type === "Amount" ? (
            <>
              {shouldBeRedacted(text) ? "" : "INR"}{" "}
              <FormatAmount price={Number(String(text)?.replaceAll(",", ""))} />{" "}
              {isAbbrevation
                ? formatTotalBalance(Number(balance), currency).abbr
                : ""}
            </>
          ) : type === "AccountNumber" ? (
            standardAccountNumberFormat(text)
          ) : (
            <TickerAnimation text={text} />
          )}
        </p>
        <div
          className="gap-x-gap-sm ml-margin-sm justify-end"
          style={{
            display: iconComponentArray?.length ? "flex" : "none",
          }}
        >
          {iconComponentArray?.map((icon, idx) => {
            return (
              <CardActionableButton
                key={idx}
                handleFunction={icon?.onClick}
                icon={icon?.icon}
                isDisabled={icon?.isDisabled}
                title={icon?.title}
                bgColor={icon?.bgColor}
                imgColor={icon?.imgColor}
              />
            );
          })}
        </div>
      </div>
      <p
        className="text-font-xs transform-none text-text-secondary"
        style={{
          display: subText ? "flex" : "none",
        }}
      >
        {subText}
      </p>
    </div>
  );
};

export default TextWithIcon;
